import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_dashboard/dostavkee/_sidebar-layout/addresses/')({
    onEnter: () => {
        document.title = 'Dostavkee - Адреса'
    },
})
